import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImageAttachment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 8C0 3.58172 3.58172 0 8 0H32L48 16V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V8Z",
			fill: "#FFCC6E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32 0L48 16H36C33.7909 16 32 14.2091 32 12V0Z",
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_641_12947)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M27.3333 33.5L23.365 26.225L26.5 21L33.1667 33.5H27.3333ZM20.6667 24.3333L25.6667 33.5H15.6667L20.6667 24.3333ZM18.5833 22.6667C18.0308 22.6667 17.5009 22.4472 17.1102 22.0565C16.7195 21.6658 16.5 21.1359 16.5 20.5833C16.5 20.0308 16.7195 19.5009 17.1102 19.1102C17.5009 18.7195 18.0308 18.5 18.5833 18.5C19.1359 18.5 19.6658 18.7195 20.0565 19.1102C20.4472 19.5009 20.6667 20.0308 20.6667 20.5833C20.6667 21.1359 20.4472 21.6658 20.0565 22.0565C19.6658 22.4472 19.1359 22.6667 18.5833 22.6667Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_641_12947",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white",
				transform: "translate(14 16)"
			})
		}) })
	]
});
export default SvgImageAttachment;
